module.exports = "<div class=\"loader\" [ngStyle]=\"{'font-size': getFontSize()}\" [ngClass]=\"[getColor(), getBtnSize()]\"></div>\n"